var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-2 bd-highlight d-block mx-auto"},[_c('p',[_vm._v(_vm._s(_vm.content)),(_vm.note)?_c('a',{attrs:{"href":'#note-' + _vm.note}},[_c('sup',[_vm._v("["+_vm._s(_vm.note)+"]")])]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }